import type { CSSProperties, ReactNode } from 'react'
import { cn } from '@/lib/utils'

/** One scene filling the window, on its own `--cycle` clock: its pages are timed off that. */
export function Screen(props: { cycle?: number; children: ReactNode; className?: string }) {
  const style: CSSProperties = { '--cycle': `${props.cycle ?? 16}s` }
  return (
    <div className={cn('absolute inset-0 flex flex-col', props.className)} style={style}>
      {props.children}
    </div>
  )
}

/** One page of a scene's loop, entering `delay` seconds into the clock. */
export function ScenePage(props: { delay: number; children: ReactNode; className?: string }) {
  return (
    <div
      className={cn('scene-page absolute inset-0 flex flex-col', props.className)}
      style={{ animationDelay: `${props.delay}s` }}
    >
      {props.children}
    </div>
  )
}
